import * as React from 'react';
export const Spaceship = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M20.24 5.72s-.584 1.06-2.195 2.687a8.574 8.574 0 01.875 3.78c0 4.347-3.226 7.951-7.455 8.637 2.478-.886 4.276-3.14 3.05-5.256-.888-1.531-3.225-1.371-5.659-.36C3.654 17.37.417 18.377.29 18.416H.286L20.24 5.72zM10.006 3.43a8.951 8.951 0 016.976 3.313c-2.616.883-8.787 4.694-11.51 5.145-1.966.326-2.694-.482-2.992-1.328-.497-1.406.106-3.73 2.054-5.284 1.485-1.187 3.408-1.846 5.472-1.846zm11.368.836c1.228-.787 2.332-.694 2.332-.694s-.357 1.03-1.586 1.817l-.353 1.65a7.114 7.114 0 00-2.073-3.12c.21.045 1.67.353 1.68.347z" />
  </svg>
);
